import { Resource, Statement, Pagination } from '@/helpers/Interfaces';
import Pager from '@/helpers/Pager';
import { UserDisplayModel } from '@/modules/core/dictionaries/services/DictionaryService';
import { axios } from '@/plugins/axios';
import { merge } from 'lodash';

const taggedUsersPagerDefaults = (): Pager => new Pager(1, 30, 'Id', 'ASC');

export default class CommentsService
{
    public static async saveComment(objectId: string, moduleName: string, comment: string, attachmentIds: string[], blueprintId: string): Promise<Statement>
    {
        return (await axios.post(`simple-command/${moduleName}/${objectId}/comments`, {
            comment: comment,
            attachmentIds: attachmentIds,
            blueprintId: blueprintId
        })).data;
    }

    public static async cleanupTemporaryAttachments(attachmentIds: string[]): Promise<void>
    {
        await axios.post('admin/comments/attachments/cleanup', {
            attachmentIds: attachmentIds
        });
    }

    public static async getCommentsList(objectId: string, moduleName: string, filter: any, pager: Pager): Promise<Pagination<Resource<CommentsListItemModel>>>
    {
        return (await axios.get(`simple-query/${moduleName}/${objectId}/comments`, {
            params: merge({}, filter, pager.data())
        })).data;
    }

    public static async getTaggedUsers(objectId: string, moduleName: string, search: string): Promise<Pagination<Resource<UserDisplayModel>>>
    {
        const pager = taggedUsersPagerDefaults();

        return (await axios.get(`simple-dictionary/${moduleName}/form/${objectId}/comments/taggedUser`, {
            params: merge({}, { search: search ?? '' }, pager.data())
        })).data;
    }
}

export interface CommentsListItemModel {
    author: CommentsAuthorModel,
    comment: string;
    attachments: CommentAttachmentModel[];
}

export interface CommentsAuthorModel {
    user: UserDisplayModel;
    impersonator: UserDisplayModel;
    dateUtc: string;
}

export interface CommentAttachmentModel {
    publicId: string;
    fileName: string;
}
